module.exports = __webpack_public_path__ + "assets/img/国际运输.fc9c6f30.svg";